import { create } from "zustand";
import { devtools } from "zustand/middleware";

import type { UserStore } from "@interfaces/index";

export const useUserStore = create<UserStore>()(
  devtools(
    (set) => ({
      userId: "",
      userFullName: "",
      clientCode: "",
      businesses: [],
      business: null,
      phone: "",
      puEnabled: false,
      disabledFeatures: [],
      redConnectedBusinessId: null,
      queriesCount: 0,
      setState: (state) => set(() => ({ ...state })),
      resetState: () =>
        set({
          userId: "",
          userFullName: "",
          clientCode: "",
          businesses: [],
          business: null,
          phone: "",
          puEnabled: false,
          disabledFeatures: [],
          redConnectedBusinessId: null,
          queriesCount: 0,
        }),
    }),
    { name: "user-storage", store: "user-storage" },
  ),
);
